import useLocalStorage from 'hooks/useLocalStorage';
import { useState } from 'react';
import useStores from './useStore';

const useReports = (auctioncore) => {
  const { UIStore } = useStores();
  const [loadingReport, setLoadingReport] = useState(false);
  const {
    vin, year, make, model, makeName, modelName, mileage, setProperty, setLoading, valueLocation,
  } = UIStore;

  const [proChartsStorage, setProChartsStorage] = useLocalStorage('pro_charts', '');
  const [proValue, setProValue] = useLocalStorage('pro_value', '');
  const [proComps, setProComps] = useLocalStorage('pro_comps', '');
  const [proCondition, setProCondition] = useLocalStorage('pro_condition', '');
  const [proConditionOptions, setProConditionOptions] = useLocalStorage('pro_condition_options', '');

  const loadFromStorage = () => {
    if (proValue) {
      setProperty('conditionScore', proValue.score);
      setProperty('predictionMonthsOut', proValue.prediction);
      if (proValue.year) setProperty('year', proValue.year);
      if (proValue.make) {
        setProperty('makeName', proValue.makeName);
        setProperty('make', proValue.make);
      }
      if (proValue.model) {
        setProperty('modelName', proValue.modelName);
        setProperty('model', proValue.model);
      }
      if (proValue.mileage) setProperty('mileage', proValue.mileage);
      if (proValue.makeName) setProperty('makeName', proValue.makeName);
      if (proValue.modelName) setProperty('modelName', proValue.modelName);
      if (proValue.vin) setProperty('vin', proValue.vin);
      if (proValue.vehicleCategory) setProperty('vehicleCategory', proValue.vehicleCategory);
    }

    if (proCondition) setProperty('condition', proCondition);

    if (proConditionOptions) setProperty('conditionOptions', proConditionOptions);

    if (proChartsStorage) setProperty('chartData', { aspjs: proChartsStorage.aspjs, aspjsCr: proChartsStorage.aspjsCr, aspjsMiles: proChartsStorage.aspjsMiles });

    if (proComps) setProperty('vehicleComparables', proComps.vehicleComparables);
  };

  const setReports = async (condition, includeCharts = false, includeValues = true, includeComps = false, newMileage = null) => {
    try {
      console.log('set reports');
      if (condition.length < 1) {
        return;
      }

      const formatCondition = [];
      condition.forEach((item) => formatCondition[item.name] = item.rating);

      let m = newMileage || mileage;

      const re = /^[0-9\b]+$/;

      if (m && m?.toUpperCase() !== 'TMU'
          && m?.toUpperCase() !== 'OHV'
          && m !== '0'
          && !re.test(m)) {
        m = 0;
        setProperty('mileage', m);
      }

      setLoadingReport(true);

      const response = await auctioncore.getValueGuidePro(model, !Number.isInteger(m) ? m?.toUpperCase() : m, formatCondition,
        includeCharts, includeValues, includeComps, valueLocation);

      console.log('esponse.data.getValueGuideProReport:', response.data.getValueGuideProReport);

      const {
        prediction, score, vehicleCategory, aspjs, aspjsCr, aspjsMiles, vehicleBrand, vehicleModel,
      } = response.data.getValueGuideProReport;

      console.log('tom')
      console.log(response.data.getValueGuideProReport)


      if (!includeCharts) {
        setProperty('condition', condition);
      }
      setProCondition(condition);

      if (includeCharts) {
        setProChartsStorage({ aspjs, aspjsCr, aspjsMiles });
        setProperty('chartData', { aspjs, aspjsCr, aspjsMiles });
        console.log('set chart data');
      }

      if (vehicleBrand) {
        setProperty('makeName', vehicleBrand);
      }
      if (vehicleModel && !modelName) {
        setProperty('modelName', vehicleModel);
      }

      if (includeValues) {
        setProValue({
          vehicleCategory,
          prediction,
          score,
          mileage: newMileage || mileage,
          year,
          make: vehicleBrand,
          model,
          makeName,
          modelName,
          vin,
        });
        setProperty('conditionScore', score);
        setProperty('predictionMonthsOut', prediction);
        setProperty('vehicleCategory', vehicleCategory);
      }

      if (includeComps) {
        const { vehicleComparables } = response.data.getValueGuideProReport;
        setProComps({ vehicleComparables });
        setProperty('vehicleComparables', vehicleComparables);
      }

      setLoadingReport(false);
    } catch (e) {
      setLoading(false);
      if (e.message.includes('Session Expired')) {
        alert('Session expired. Please login again');
      }
      console.log(e);
    }
  };

  const resetStorage = () => {
    localStorage.removeItem('pro_charts');
    localStorage.removeItem('pro_value');
    localStorage.removeItem('pro_comps');
    localStorage.removeItem('pro_condition');
    localStorage.removeItem('pro_condition_options');
  };

  return {
    setReports, loadFromStorage, resetStorage, loadingReport,
  };
};

export default useReports;
